/**
 * desktop-nav-defer.js
 *
 * On mobile viewports (< 960px), removes desktop mega-nav dropdown elements
 * from the DOM to reduce element count. Restores them if the viewport
 * widens to desktop size (e.g. orientation change or resize).
 */
(function () {
  'use strict';

  var BREAKPOINT = 960;
  var removedEls = null;
  var placeholders = null;
  var isMobileState = null;

  function removeMeganavs() {
    if (removedEls) return;
    removedEls = [];
    placeholders = [];

    var meganavs = document.querySelectorAll('.header__row-desktop .meganav');
    for (var i = 0; i < meganavs.length; i++) {
      var el = meganavs[i];
      var placeholder = document.createComment('meganav-placeholder');
      el.parentNode.insertBefore(placeholder, el);
      el.parentNode.removeChild(el);
      removedEls.push(el);
      placeholders.push(placeholder);
    }
  }

  function restoreMeganavs() {
    if (!removedEls) return;
    for (var i = 0; i < placeholders.length; i++) {
      var ph = placeholders[i];
      if (ph.parentNode && removedEls[i]) {
        ph.parentNode.insertBefore(removedEls[i], ph);
        ph.parentNode.removeChild(ph);
      }
    }
    removedEls = null;
    placeholders = null;
  }

  function handleViewport() {
    var mobile = window.innerWidth < BREAKPOINT;
    if (mobile === isMobileState) return;
    isMobileState = mobile;
    if (mobile) {
      removeMeganavs();
    } else {
      restoreMeganavs();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    handleViewport();

    var mql = window.matchMedia('(max-width: ' + (BREAKPOINT - 1) + 'px)');
    if (mql.addEventListener) {
      mql.addEventListener('change', handleViewport);
    } else {
      mql.addListener(handleViewport);
    }
  });
})();
